// useDistributor.js
import { useState, useEffect } from "react";

export const useDistributor = () => {
  const [distributor, setDistributor] = useState(null);

  useEffect(() => {
    const storedDistributor = localStorage.getItem("distributor");
    if (storedDistributor) {
      setDistributor(JSON.parse(storedDistributor));
    }
  }, []);

  return distributor;
};
